import React from 'react'
import { t } from 'i18next'
import dayjs from 'dayjs'
import { Link } from 'react-router-dom'
import { Button } from 'antd'
import { FormOutlined } from '@ant-design/icons'

const actions = (chat) => {
  if (chat.owner_type === 'Appointment') {
    return <Link to={`/admin/appointments/${chat.owner_id}?from=chat`}><Button shape="circle" icon={<FormOutlined />} /></Link>
  } else {
    return <Link to={`/admin/interveners/${chat.owner_id}`}><Button shape="circle" icon={<FormOutlined />} /></Link>
  }
}

const boxRender = (chat, boxes) => {
  if (chat.owner_type === 'Appointment') {
    return boxes.find(box => box.id === chat.owner.box_id).name
  } else if (!chat.owner.box_ids) {
    return ''
  } else {
    return boxes.filter(box => chat.owner.box_ids.includes(box.id)).map(box => box.name).join(' | ')
  }
}

export const chatColumns = (boxes) => [
  {
    title: t('Admin.ChatList.date'),
    dataIndex: 'date',
    key: 'date',
    width: 120,
    render: (_, o) => dayjs(o.last_message?.created_at).format('dddd DD MMMM à HH:mm:ss')
  },
  {
    title: t('Admin.ChatList.summary'),
    dataIndex: 'summary',
    key: 'summary',
    width: 200,
    ellipsis: true,
    render: (_, o) => o.last_message?.content
  },
  {
    title: t('Admin.ChatList.owner'),
    dataIndex: 'owner',
    key: 'owner',
    width: 80,
    render: (_, o) => {
      const type = t(`Admin.Chat.attributes.owner.${o.owner.type || 'Intervener'}`)
      return `${o.owner.name} (${type})`
    }
  },
  {
    title: t('Admin.ChatList.box'),
    width: 150,
    dataIndex: 'box',
    key: 'box',
    render: (_, o) => boxRender(o, boxes)
  },
  {
    title: t('Admin.ChatList.appointment'),
    width: 150,
    dataIndex: 'appointment',
    key: 'appointment',
    render: (_, o) => {
      let value = ''
      if (o.owner_type === 'Appointment') {
        value = `${dayjs(o.owner.begin_date).format('dddd DD MMMM à HH:mm:ss')} ${o.owner.assigned_short_name || ''}`
      }
      return value
    }
  },
  {
    width: 50,
    key: 'action',
    render: (_, o) => actions(o)
  }
]
